/**
 * Created by masoud on 05/05/17.
 */
import React from "react";
import createClass from "create-react-class";
//import DownloadButton from "../../common/DownloadButton.react";

const SnappIntro = createClass({
  render() {
    return (
      <div className="Snapp-Intro">
        <div className="Introduction">
          <h1>تاکسی اینترنتی اسنپ را بشناسید</h1>
          <p>
            اسنپ، اولین و بزرگ‌ترین تاکسی اینترنتی ایران، پل ارتباطی میان کاربر مسافر و کاربر راننده است و راهکاری سریع و ساده برای درخواست خودرو و موتورسیکلت به شمار می‌رود. 
            با درخواست خودرو یا موتورسیکلت در این اپلیکیشن، پس از مشخص کردن مبدا و مقصد، نزدیک‌ترین اسنپ به نشانی شما می‌آید.
             با اسنپ سفری ایمن، راحت و مقرون‌به‌صرفه را تجربه خواهید کرد.
          </p>
          {/* <DownloadButton/> */}
        </div>
      </div>
    );
  }
});

module.exports = SnappIntro;



// WEBPACK FOOTER //
// ./src/js/components/Pages/MainPage/SnappIntro.react.js